module.exports = __webpack_public_path__ + "img/direction_img2.7620d491.png";